import React from 'react';
import { motion } from 'framer-motion';
import '../csscomponent/CoinEffects.css';

export default function CoinEffects({
  topText = 'SERVICES AND DEVELOPER',
  bottomText = 'SERVICES AND DEVELOPER',
  centerText = '24/7',
  label = 'Support Coverage',
  className = '',
}) {
  return (
    <motion.div
      className={`coin-effects ${className}`.trim()}
      initial={{ opacity: 0, y: 20, scale: 0.96 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.55, ease: 'easeOut' }}
    >
      <span className="coin-effects-glow" aria-hidden="true" />
      <svg className="coin-effects-svg" viewBox="0 0 350 350" role="img" aria-label={`${centerText} ${label}`}>
        <defs>
          <path
            id="coin-top-arc"
            d="M 58 175
               A 117 117 0 0 1 292 175"
          />
          <path
            id="coin-bottom-arc"
            d="M 292 175
               A 117 117 0 0 1 58 175"
          />
          <radialGradient id="coin-core-gradient" cx="35%" cy="30%" r="70%">
            <stop offset="0%" stopColor="#f8fbff" />
            <stop offset="35%" stopColor="#d7e9ff" />
            <stop offset="68%" stopColor="#7dd3fc" />
            <stop offset="100%" stopColor="#0f3b66" />
          </radialGradient>
        </defs>

        <circle className="coin-effects-rim coin-effects-rim-outer" cx="175" cy="175" r="156" />
        <circle className="coin-effects-rim coin-effects-rim-mid" cx="175" cy="175" r="139" />
        <circle className="coin-effects-core" cx="175" cy="175" r="118" />
        <g className="coin-effects-ring-copy">
          <text x="56" y="175" textAnchor="middle" className="coin-effects-star">
            *
          </text>
          <text x="294" y="175" textAnchor="middle" className="coin-effects-star">
            *
          </text>

          <text className="coin-effects-arc">
            <textPath href="#coin-top-arc" startOffset="50%">
              {topText}
            </textPath>
          </text>

          <text className="coin-effects-arc coin-effects-arc-bottom">
            <textPath href="#coin-bottom-arc" startOffset="50%">
              {bottomText}
            </textPath>
          </text>
        </g>

        {centerText === 'S&D' ? (
          <text x="175" y="175" textAnchor="middle" className="coin-effects-center">
            <tspan className="coin-effects-center-warm">S&amp;</tspan>
            <tspan className="coin-effects-center-cool">D</tspan>
          </text>
        ) : (
          <text x="175" y="175" textAnchor="middle" className="coin-effects-center">
            {centerText}
          </text>
        )}
        {label ? (
          <text x="175" y="208" textAnchor="middle" className="coin-effects-subline">
            {label}
          </text>
        ) : null}

      </svg>
    </motion.div>
  );
}
